import React from 'react';
import Dots from 'assets/icons/dots.svg?react';
import { AppMenu, AppMenuItem } from 'components/uikit/menu/AppMenu';
import { PermissionGate } from 'helpers/projectPermissions/PermissionGate.tsx';
import { PermissionRequirement } from 'helpers/projectPermissions/types/projectPermission.ts';
import styles from '../DocumentListItem.module.scss';

type TreeItemDotMenuProps = {
  permissions: PermissionRequirement[];
  menuItems: AppMenuItem[];
  anchorRef: React.RefObject<HTMLElement | null>;
  isOpen: boolean;
  onShow: (ev: React.MouseEvent<HTMLElement>) => void;
  onClose: () => void;
};

/** Dot menu for a tree item, showing actions based on permissions. */
export const TreeItemDotMenu = ({
  permissions,
  menuItems,
  anchorRef,
  isOpen,
  onShow,
  onClose,
}: TreeItemDotMenuProps) => (
  <PermissionGate permissions={permissions}>
    <div
      className={styles.dotMenuImage}
      ref={anchorRef as any}
      onClick={onShow}
      data-test-id="dot-menu"
    >
      <Dots />
    </div>
    <AppMenu
      className={styles.contextualMenu}
      anchorEl={anchorRef.current}
      open={isOpen}
      onClose={onClose}
      menuItems={menuItems}
      anchorOrigin={{ horizontal: 26, vertical: 'bottom' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    />
  </PermissionGate>
);
